module.exports = __webpack_public_path__ + "static/media/location9.d269aaf0.jpg";